import { z } from "zod";
import { sessionSummarySchema } from "./sessions.js";
export const sessionChannelLinkReasonSchema = z.enum([
    "context",
    "read",
    "created",
    "updated",
    "attached",
]);
export const listSessionChannelActivityParamsSchema = z.object({
    channelId: z.string().trim().min(1).max(200),
    cursor: z.string().trim().min(1).max(2048).optional(),
    limit: z.coerce.number().int().min(1).max(100).default(20),
});
export const sessionChannelActivitySchema = z.object({
    session: sessionSummarySchema,
    channelId: z.string().trim().min(1),
    reasons: z.array(sessionChannelLinkReasonSchema),
    viewIds: z.array(z.string().trim().min(1)),
    firstSeenAt: z.number(),
    lastSeenAt: z.number(),
    lastRunId: z.string().trim().min(1).nullable(),
});
export const listSessionChannelActivityResponseSchema = z.object({
    activities: z.array(sessionChannelActivitySchema),
    nextCursor: z.string().nullable(),
    hasMore: z.boolean(),
});
